module.exports = __webpack_public_path__ + "img/0060.ab994e45.png";